import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import "swiper/css"; 
import "swiper/css/navigation";  
import Link from "@/components/common/Link";
import service_data from "@/data/service-data";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function HowWeWorkHomeOne() {
  const { messages, lang } = useI18n();
  const howWeWork = messages.howWeWork;
  const services = messages.services.items;

  // Map service data with translations
  const translatedServices = service_data.map((item, index) => {
    const serviceKeys = ['transport', 'oils', 'tires', 'batteries', 'spareParts', 'carAccessories', 'maintenance', 'distribution'];
    const key = serviceKeys[index] || serviceKeys[0];
    const translatedService = services[key] || services.transport;
    return {
      ...item,
      title: translatedService.title,
      description: translatedService.description,
    };
  });

  return (
    <section className="how-works-section">
      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row g-5 align-items-end justify-content-between">
          <div className="col-12 col-sm-6 col-xxl-5">
            <div className="section-heading">
              <span className="subtitle">{howWeWork.subtitle}</span>
              <h2 className="mb-0">{howWeWork.title}</h2>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-xxl-5">
            <div className="section-heading">
              <p className="mb-0">{howWeWork.description}</p>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider-sm"></div>

      <div className="container">
        <div className="row g-5">
          <div className="col-12 col-sm-5">
            <div className="section-heading translateY10 pe-xxl-5">
              <Image src="/assets/img/bg-img/MicrosoftTeams-image-12.png" alt="" width={1000} height={1000} priority/>
            </div>
          </div>

          <div className="col-12 col-sm-7">
            <div className="how-works-section">
              {/* <!-- Get Started Button --> */}
              <Link href="/services" className="get-started-btn" style={{ color: '#ffffff' }}>
                <h6 className="mb-0" style={{ color: '#ffffff' }}>{howWeWork.viewAllServices}</h6>
                <span><i className="ti ti-arrow-right"></i></span>
              </Link>

              {/* <!-- Divider --> */}
              <div className="divider-sm"></div>

              {/* <!-- Service Swiper --> */}
              <Swiper
                loop={translatedServices.length > 1}
                slidesPerView={1}
                spaceBetween={24}
                pagination={{
                  el: ".service-pagination",
                  clickable: true,
                }}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                modules={[Pagination, Autoplay, Navigation]}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                  },
                  992: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  }
                }}
                key={`service-swiper-${lang}`}
                className="swiper service-swiper" 
                id="serviceSwiper"
                dir={lang === "ar" ? "rtl" : "ltr"}>
                {translatedServices.map((item, i) => (
                  <SwiperSlide key={i} className="swiper-slide">
                    <div className="service-card service-card-white">
                      {/* <!-- Shape --> */}
                      <div className="shape">
                        <Image className="w-auto h-auto" src="/assets/img/core-img/shape7.png" alt="" width={1000} height={1000} priority/>
                      </div>
                      <div className="service-icon">
                        {item.icon.startsWith('/') ? (
                          <Image 
                            src={item.icon} 
                            alt={item.title} 
                            width={40} 
                            height={40}
                          />
                        ) : (
                          <i className={`${item.icon}`}></i>
                        )}
                      </div>
                      <h4 className="mb-4">{item.title}</h4>
                      <p className="mb-0">{item.description}</p>
                    </div>
                  </SwiperSlide>
                ))}
                
              </Swiper>

              {/* <!-- Service Pagination --> */}
              <div className="service-pagination"></div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}
